// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"425c8f7d","605":"0b8a1629","753":"17c21a8d","981":"119a7079"}[chunkId] + ".chunk.js";
};